import auth from "@/shared/api/auth";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom"


export const VerificationPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (params.id && params.token) {
            auth.emailVerification(params.id, params.token).then(status => {
                console.log(status)
                if (status) {
                    navigate("/auth");
                }
            });
        }
    }, [])

    return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-olive-50">
            <h1 className="text-3xl font-bold">Подтверждение адреса электронной почты</h1>
        </div>
    )
}